"use strict";
require('../../layouts/web');

var IpixAboutUs = function() {
    var initCarousels = function(e) {
        var officeCarousalOptions = IpixJson.options.owlcarousel;
        officeCarousalOptions.loop = true;
        officeCarousalOptions.nav = true;
        officeCarousalOptions.responsive = {
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 3 }
        };
        $('.office-slider').owlCarousel(officeCarousalOptions);

        var teamsCarousalOptions = IpixJson.options.owlcarousel;
        teamsCarousalOptions.loop = true;
        teamsCarousalOptions.margin = 25;
        teamsCarousalOptions.nav = false;
        teamsCarousalOptions.dots = true;
        teamsCarousalOptions.responsiveClass = true;
        teamsCarousalOptions.responsive = {
            0: { items: 1 },
            420: { items: 2 },
            600: { items: 3 },
            1000: { items: 4 }
        };

        $('.team-slider').owlCarousel(teamsCarousalOptions);
        var testimonalCarousalOptions = IpixJson.options.owlcarousel;
        testimonalCarousalOptions.autoplay = false;
        testimonalCarousalOptions.responsive = {
            0: { items: 1 },
            576: { items: 2 },
            1000: { items: 3 }
        };
        $('.testimonal').owlCarousel(testimonalCarousalOptions);
    }



    // Public methods
    return {
        init: function() {
            initCarousels();
        }
    }
}();

// On document ready
IpixUtil.onDOMContentLoaded(function() {
    IpixAboutUs.init();
});